import { Component, forwardRef, Input } from "@angular/core";

import { MultiSelectMenuComponent } from "../../../form/multi-select-menu/multi-select-menu.component";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectMenuOption } from "../../../form/select-menu/select-menu.component";
import { GlobalDataService } from "../../../_services/global-data.service";

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectOrgansCustomMultiSelectComponent),
  multi: true,
};
@Component({
  selector: "select-organs-custom-multi-select",
  templateUrl: "select-organs-custom-multi-select.component.html",
  styleUrls: [
    "../../../form/select-menu/select-menu.component.scss",
    "../../../form/multi-select-menu/multi-select-menu.component.scss",
    "select-organs-custom-multi-select.component.scss",
  ],

  animations: [
    trigger("transformMenu", [
      state(
        "void",
        style({
          opacity: 0,
          transform: "scale(0.8)",
        })
      ),
      transition(
        "void => enter",
        animate(
          "120ms cubic-bezier(0, 0, 0.2, 1)",
          style({
            opacity: 1,
            transform: "scale(1)",
          })
        )
      ),
      transition(
        "* => void",
        animate("100ms 25ms linear", style({ opacity: 0 }))
      ),
    ]),
  ],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class SelectOrgansCustomMultiSelectComponent extends MultiSelectMenuComponent {
  public selectedOptions: SelectMenuOption[] = [];
  @Input() public setSelectedOptions(newSelectedOptions: SelectMenuOption[]) {
    this.selectedOptions = newSelectedOptions;
    this.updateDisplayedValue();
    this.onTouchedCallback();
    this.onChangeCallback(this.selectedOptions);
  }

  public getOrganTypeName(organType: "circle" | "county" | "nest"): string {
    return GlobalDataService.organTypeToText(organType);
  }
  // @ts-ignore
  public clickedOption($event: MouseEvent, key: string, customValue: any) {
    this.selectedOptions = this.selectedOptions || [];
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    const optionsWithIds = this.menuOptions.filter((o) => o.key === key);

    let optionClicked = this.menuOptions.find((o) => o.key === key);
    if (optionsWithIds && optionsWithIds.length > 1) {
      optionClicked = optionsWithIds.find(
        (o) => o.customValue.type === customValue.type
      );
    }
    if (this.selectedOptions.map((o) => o.key).includes(optionClicked.key)) {
      this.selectedOptions = this.selectedOptions.filter(
        (o) => o.key !== optionClicked.key
      );
    } else {
      this.selectedOptions = this.selectedOptions.concat(optionClicked);
    }

    this.menuEvent.emit(this.selectedOptions);
    this.updateDisplayedValue();
    this.onTouchedCallback();
    this.onChangeCallback(this.selectedOptions);
  }
  protected updateFilteredMenuOptions(menuOptions: SelectMenuOption[]) {
    this._filteredMenuOptions = this.filterText.trim().length
      ? menuOptions.filter(
          (o) =>
            o.text.includes(this.filterText) ||
            this.selectedOptions.some((selected) => selected.key === o.key)
        )
      : menuOptions;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/select-organs/select-organs-custom-multi-select/select-organs-custom-multi-select.component.ts